import { useState, useEffect } from 'react';

const STORAGE_PREFIX = 'knowindia_dash_';

/**
 * Hook to persist state in localStorage so it survives page refresh.
 * @param {string} key - Storage key (will be prefixed with knowindia_dash_)
 * @param {*} initialValue - Initial value if nothing in storage
 * @returns {[*, Function]} [value, setValue]
 */
export function usePersistedState(key, initialValue) {
  const storageKey = key.startsWith(STORAGE_PREFIX) ? key : `${STORAGE_PREFIX}${key}`;

  const [value, setValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(storageKey);
      if (item === null) return initialValue;
      return JSON.parse(item);
    } catch {
      return initialValue;
    }
  });

  useEffect(() => {
    try {
      if (value === undefined || value === null) {
        window.localStorage.removeItem(storageKey);
      } else {
        window.localStorage.setItem(storageKey, JSON.stringify(value));
      }
    } catch (error) {
      console.error('usePersistedState: failed to write', storageKey, error);
    }
  }, [storageKey, value]);

  return [value, setValue];
}

export default usePersistedState;
